/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditArticleAttributes } from '../../models/edit-article-attributes';
import { EnrichedVirtualArticle } from '../../models/enriched-virtual-article';
import { KeyType } from '../../models/key-type';

export interface EditBundleGroupVirtualArticleAttributes$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
  virtualArticleKey: string;
      body: EditArticleAttributes
}

export function editBundleGroupVirtualArticleAttributes(http: HttpClient, rootUrl: string, params: EditBundleGroupVirtualArticleAttributes$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrichedVirtualArticle>> {
  const rb = new RequestBuilder(rootUrl, editBundleGroupVirtualArticleAttributes.PATH, 'patch');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.path('virtualArticleKey', params.virtualArticleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrichedVirtualArticle>;
    })
  );
}

editBundleGroupVirtualArticleAttributes.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/edit';
